<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h1>Cara Menghemat Pengeluaran Ketika Berlibur</h1>
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Liburan natal dan akhir tahun adalah momen yang sangat ditunggu-tunggu untuk berlibur baik bersama teman ataupun keluarga. Kebanyakan dari kita pasti akan memanfaatkan momen ini dengan sebaik mungkin sebelum kita memulai tahun yang baru.Mendengar kata liburan, berarti kita harus siap menghabiskan uang yang banyak untuk berlibur. Tapi, bagaimana jika ternyata kita tetap bisa berhemat dan tidak perlu mengeluarkan uang yang banyak untuk liburan kali ini?
          </p>
          <p class="mt-3 text-justify">
            &emsp;Nah StarGuides akan kasih beberapa tips bagaimana caranya kita tetap bisa menghemat pengeluaran ketika kita liburan:
          </p>

          <h3 class="text-left">1. Booking tiket dan hotel dari jauh hari</h3>
          <b-img :src="require('@/assets/img/articles/191014/Picture1.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Memesan tiket dan hotel dari jauh-jauh hari akan membuat pengeluaran kalian menjadi lebih kecil karna harga yang di berikan oleh maskapai dan hotel masih terbilang cukup murah jika dibandingkan ketika kita memesan dalam waktu yang dekat dari tanggal liburan. Semakin jauh jarak kita memesan maka akan semakin murah juga dan tentunya itu akan menghemat pengeluaran kita.
          </p>

          <h3 class="text-left">2. Memilih hotel bintang satu atau homestay</h3>
          <b-img :src="require('@/assets/img/articles/191014/Picture2.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Hotel bintang satu bisa menjadi pilihan alternatif untuk menginap selama liburan. Jika hanya transit, tidak ada salahnya kita memilih homestay sebagai tempat tidur untuk sementara. Karna dengan cara ini kalian bisa menyimpan kelebihan budget kalian untuk hal-hal yang lain.
          </p>

          <h3 class="text-left">3. Gunakan transportasi umum</h3>
          <b-img :src="require('@/assets/img/articles/191014/Picture3.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Ketika kita sedang berlibur, jangan menggunakan taksi sebagai transportasi kalian. Sebaliknya,  gunakanlah angkutan umum seperti kereta dan bus. Selain lebih murah, kita jadi lebih mengetahui tempat yang akan kita kunjungi dengan menggunakan transportasi umum.
          </p>

          <h3 class="text-left">4. Membawa makanan ringan dan minuman</h3>
          <b-img :src="require('@/assets/img/articles/191014/Picture4.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Meskipun terdengar cukup spele, namun cara ini cukup efektif untuk menghemat pengeluaran kalian. Karna biasanya harga makanan ringan serta air minum di tempat wisata akan menjadi sangat mahal, oleh karna itu jangan lupakan hal yang satu ini dan membawanya ke dalam tas kalian.
          </p>

          <h3 class="text-left">5. Cari tempat wisata gratis</h3>
          <b-img :src="require('@/assets/img/articles/191014/Picture5.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Kalian bisa mencari tempat wisata yang tidak dipungut biaya seperti ke pantai atau taman jika kalian tidak ingin mengeluarkan uang yang banyak. Pergi ke museum juga bisa menjadi salah satu cara terbaik untuk menghemat pengeluaran kalian. Selain gratis, datang ke museum juga akan membuat wawasan kalian jadi bertambah serta membuat liburan kalian tetap berkesan.
          </p>

          <p class="mt-3 text-justify">
            &emsp;Itu dia beberapa tips dari StarGuides yang bisa kalian coba saat ingin berlibur nanti jika kalian ingin menghemat budget liburan kalian. Selamat mencoba!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12" class="text-center">
          <h3>Cara Menghemat Pengeluaran Ketika Berlibur</h3>
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Liburan natal dan akhir tahun adalah momen yang sangat ditunggu-tunggu untuk berlibur baik bersama teman ataupun keluarga. Kebanyakan dari kita pasti akan memanfaatkan momen ini dengan sebaik mungkin sebelum kita memulai tahun yang baru.
            <br>
            &emsp;Mendengar kata liburan, berarti kita harus siap menghabiskan uang yang banyak untuk berlibur. Tapi, bagaimana jika ternyata kita tetap bisa berhemat dan tidak perlu mengeluarkan uang yang banyak untuk liburan kali ini?
          </p>
          <p class="mt-3 text-justify">
            &emsp;Nah StarGuides akan kasih beberapa tips bagaimana caranya kita tetap bisa menghemat pengeluaran ketika kita liburan:
          </p>

          <h5 class="text-left">1. Booking tiket dan hotel dari jauh hari</h5>
          <b-img :src="require('@/assets/img/articles/191014/Picture1.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Memesan tiket dan hotel dari jauh-jauh hari akan membuat pengeluaran kalian menjadi lebih kecil karna harga yang di berikan oleh maskapai dan hotel masih terbilang cukup murah jika dibandingkan ketika kita memesan dalam waktu yang dekat dari tanggal liburan. Semakin jauh jarak kita memesan maka akan semakin murah juga dan tentunya itu akan menghemat pengeluaran kita.
          </p>

          <h5 class="text-left">2. Memilih hotel bintang satu atau homestay</h5>
          <b-img :src="require('@/assets/img/articles/191014/Picture2.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Hotel bintang satu bisa menjadi pilihan alternatif untuk menginap selama liburan. Jika hanya transit, tidak ada salahnya kita memilih homestay sebagai tempat tidur untuk sementara. Karna dengan cara ini kalian bisa menyimpan kelebihan budget kalian untuk hal-hal yang lain.
          </p>

          <h5 class="text-left">3. Gunakan transportasi umum</h5>
          <b-img :src="require('@/assets/img/articles/191014/Picture3.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Ketika kita sedang berlibur, jangan menggunakan taksi sebagai transportasi kalian. Sebaliknya,  gunakanlah angkutan umum seperti kereta dan bus. Selain lebih murah, kita jadi lebih mengetahui tempat yang akan kita kunjungi dengan menggunakan transportasi umum.
          </p>

          <h5 class="text-left">4. Membawa makanan ringan dan minuman</h5>
          <b-img :src="require('@/assets/img/articles/191014/Picture4.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Meskipun terdengar cukup spele, namun cara ini cukup efektif untuk menghemat pengeluaran kalian. Karna biasanya harga makanan ringan serta air minum di tempat wisata akan menjadi sangat mahal, oleh karna itu jangan lupakan hal yang satu ini dan membawanya ke dalam tas kalian.
          </p>

          <h5 class="text-left">5. Cari tempat wisata gratis</h5>
          <b-img :src="require('@/assets/img/articles/191014/Picture5.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Kalian bisa mencari tempat wisata yang tidak dipungut biaya seperti ke pantai atau taman jika kalian tidak ingin mengeluarkan uang yang banyak. Pergi ke museum juga bisa menjadi salah satu cara terbaik untuk menghemat pengeluaran kalian. Selain gratis, datang ke museum juga akan membuat wawasan kalian jadi bertambah serta membuat liburan kalian tetap berkesan.

          <p class="mt-4 text-justify">
            &emsp;Itu dia beberapa tips dari StarGuides yang bisa kalian coba saat ingin berlibur nanti jika kalian ingin menghemat budget liburan kalian. Selamat mencoba!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191014',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191014.vue